<template>
  <div class="flex diy-button-group">
    <div
      v-for="(item, index) in list"
      :key="index"
      class="button-item text-12px px-4px py-5px cursor-pointer min-w-32px text-center"
      @click="buttonClick(item)"
      :class="{
        active: value === item,
        '!text-14px': textSize,
      }"
    >
      <span class="bg-clip-text">{{ item }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      },
    },
    value: {
      type: String,
      require: true,
    },
    textSize: {
      type: String,
      default: () => {},
    },
  },
  methods: {
    buttonClick(button) {
      this.$emit('input', button)
      this.$emit('button-click', button)
    },
  },
}
</script>

<style scoped lang="scss">
.diy-button-group {
  // box-shadow: 0px 0px 2.7px 0px #0079c2;
  .button-item {
    border: 0.68px solid #7cb8ff80;
    span {
      color: #fff;
      // background-image: linear-gradient(180deg, #fff 0%, #a7dfff 100%);
      // -webkit-text-fill-color: transparent;
    }
    &:first-child {
      border-top-left-radius: 1.35px;
      border-bottom-left-radius: 1.35px;
    }
    &:last-child {
      border-top-right-radius: 1.35px;
      border-bottom-right-radius: 1.35px;
    }
    &.active {
      background: linear-gradient(0deg, #221800, #221800), linear-gradient(0deg, #e7c177, #e7c177);
      border-color: #e7c177;
      box-shadow: 0px 0px 24px 0px #ffa800 inset;
      span {
        background-image: linear-gradient(180deg, #fff 0%, #e7c177 100%);
      }
    }
  }
}
</style>
